export default __webpack_public_path__ + "static/banner-surviving-the-silly-season-on-a-budget-6a78d90061908d8550537e463e721f0a.jpg";